import {
  Component,
  OnInit,
  ElementRef
} from '@angular/core';

import { ITimeLine } from '../../shared';

import * as d3 from 'd3';

@Component({
  selector: '[awair-dotted-line]',
  templateUrl: './dotted-line.component.html',
  styleUrls: ['./dotted-line.component.scss']
})
export class DottedLineComponent implements OnInit {

  private isInitialized: boolean = false;

  constructor(private el: ElementRef) { }

  ngOnInit() {
  }

  update(dottedTimeline: ITimeLine, lineGenerator: any): void {
    if (this.isInitialized) {
      d3.select(this.el.nativeElement)
        .selectAll('path')
        .remove();
    }

    if (lineGenerator && dottedTimeline != null) {
      d3.select(this.el.nativeElement)
        .append('path')
        .attr('class', 'line')
        .style('stroke-dasharray', ('2, 2'))
        .style('stroke', '#ACB4BB')
        .style('stroke-width', '1px')
        .attr('d', lineGenerator(dottedTimeline));

      this.isInitialized = true;
    }
  }
}
